export enum EditorStatus {
    Create = "Create",
    Update = "Update",
    Duplicate = "Duplicate",
    Delete = "Delete"
}